import { Controller } from "@hotwired/stimulus"
import JSConfetti from 'js-confetti'

export default class extends Controller {
  static values = { subscriptionCount: Number }

  connect() {
    const pool = ['🫶🏻','😁','😅','🤣','😂','🙂','😉','😍','🤩','😘','🥲','🤔','🫡','🥵','🥳','😎','😭','😱','❤️','💚','💙','🤍','💬','👋','🤞','👉','👇','👍','👏','🫶','🤝','🙏','💪','🫀','👀','🐕','🐱','🌴','🌿','🎂','☕','🍾','🍻','🌍','⛰️','🏖️','🚗','🚚','🚲','🚨','✈️','⌛','☀️','🌞','⭐','🔥','💧','🌊','🎆','🎉','🎁','🏆','⚽','🎯','🎨','👑','🎓','💎','📢','🎵','🎤','☎️','💻','🎥','🎬','📷','🔎','💡','📚','📧','📅','📈','📍','⚔️','🫧','⚠️','🔞','➡️','⬇️','❓','⚕️','♻️','✅','✔️','❌','🔴','🟢','🇩🇿','🇫🇷']
    const jsConfetti = new JSConfetti();
    console.log(this.subscriptionCountValue);
    jsConfetti.addConfetti( {
      emojis: pool.sort(() => Math.random() - 0.5),
      emojiSize: 50,
      confettiNumber: this.subscriptionCountValue,
    });
  }
}
